import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  ScrollView,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import { Ionicons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { Menu, MenuItem } from "react-native-material-menu";
import { useTranslation } from "react-i18next";
import SyncStatusIndicator from "../../Components/SyncStatusIndicator";
import { useScreenDimensions, useDevice } from "../../_layout";
import BackButton from "../../Components/BackButton";
import CustomAlert from "../../Components/CustomAlert";
import {
  getClientGameDayCompetitionLevels,
  getWeightClasses,
  hasFederationFamilyChanged,
  mapWeightClass,
} from "./competitionFederationConfig";

const ClientGameDay = ({ competition, client }) => {
  const { t } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const coach = client.coach;
  const compExercises = ["squat", "bench press", "deadlift"];
  const attempts = ["OPENER", "2ND ATTEMPT", "3RD ATTEMPT"];
  const qualityAttempts = ["good", "medium", "bad"];

  const [showingFederationChangeAlert, setShowingFederationChangeAlert] =
    useState(false);
  const [pendingCompetitionLevel, setPendingCompetitionLevel] = useState("");

  const competitionLevels = getClientGameDayCompetitionLevels(
    competition.competitionLevel
  );
  const competitionClasses = ["Subjunior", "Junior", "Open", "Master"];

  const applyCompetitionLevelChange = (
    selectedCompetitionLevel,
    skipConfirmation = false
  ) => {
    const previousLevel = competition.competitionLevel;
    const shouldChangeFamily = hasFederationFamilyChanged(
      previousLevel,
      selectedCompetitionLevel
    );

    if (
      shouldChangeFamily &&
      competition.weightClass &&
      skipConfirmation !== true
    ) {
      setPendingCompetitionLevel(selectedCompetitionLevel);
      setShowingFederationChangeAlert(true);
      return;
    }

    if (shouldChangeFamily && competition.weightClass) {
      const mappedWeightClass = mapWeightClass(
        competition.weightClass,
        previousLevel,
        selectedCompetitionLevel,
        client.gender
      );
      if (mappedWeightClass !== competition.weightClass) {
        competition.setProperty("weightClass", mappedWeightClass);
      }
    }

    competition.setProperty("competitionLevel", selectedCompetitionLevel);
  };

  useEffect(() => {
    (async () => {
      await client.syncStatusManager.safeOperation("listenerCompetition", () =>
        client.firestoreListener.setupCompetitionsListener(competition.id)
      );
    })();

    return () => {
      client.firestoreListener.removeCompetitionsListener();
    };
  }, [client, competition.id]);

  const CompetitionHeaderTop = observer(() => {
    return (
      <View
        style={{
          width: "100%",
        }}
      >
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              justifyContent: "space-between",
            },
          ]}
        >
          <View style={{ alignItems: "center" }}>
            <BackButton
              action={() => {
                competition.setIsSelected(false);
                client.setIsSelectedComp(false);
              }}
              backString={t("back-string")}
            />
          </View>

          <Text
            style={[
              Fonts.medium18,
              {
                marginHorizontal: screenSize === "small" ? 8 : 12,
                textAlign: "center", // Add this line to center the text horizontally
              },
            ]}
            numberOfLines={2}
          >
            {competition.name}
          </Text>

          <View
            style={{
              // width: "10%",
              alignItems: "flex-end",
              justifyContent: "center",
              paddingLeft: 32,
            }}
          >
            <SyncStatusIndicator
              syncStatusManager={client.syncStatusManager}
              onPress={() => client.performTransaction()}
            />
          </View>
        </View>
        <View
          style={{
            backgroundColor: Colors.blackColor,
            height: 1,
            opacity: 0.2,
            marginTop: 8,
          }}
        />
      </View>
    );
  });

  const AthleteInfo = () => {
    const [athleteMenu, setAthleteMenu] = useState(false);
    const showAthleteMenu = () => setAthleteMenu(true);

    const [searchAthlete, setSearchAthlete] = useState("");

    const RequestClose = () => {
      setSearchAthlete("");
      setAthleteMenu(false);
    };

    const selectAthlete = (selectedClient) => {
      coach.setSelectedClientComp(selectedClient);
      coach.selectedClientComp.setSelectedCompetition(competition);
      setAthleteMenu(false);
    };

    const [classMenu, setClassMenu] = useState(false);
    const showClassMenu = () => setClassMenu(true);
    const selectCompetitionClass = (selectedCompetitionClass) => {
      competition.setProperty("competitionClass", selectedCompetitionClass);
      setClassMenu(false);
    };

    const [weightClassMenu, setWeightClassMenu] = useState(false);
    const showWeightClassMenu = () => setWeightClassMenu(true);
    const selectWeightClass = (selectedWeightClass) => {
      competition.setProperty("weightClass", selectedWeightClass);
      setWeightClassMenu(false);
    };

    const [levelMenu, setLevelMenu] = useState(false);
    const showLevelMenu = () => setLevelMenu(true);
    const selectCompetitionLevel = (selectedCompetitionLevel) => {
      applyCompetitionLevelChange(selectedCompetitionLevel);
      setLevelMenu(false);
    };

    const weightClasses = getWeightClasses(
      competition.competitionLevel,
      client.gender
    );

    const ClientsMenu = () => {
      const [isHovered, setIsHovered] = useState(false);

      const MenuItemView = ({ cl }) => {
        const [isHovered, setIsHovered] = useState(false);

        return (
          <MenuItem
            onPress={() => selectAthlete(cl)} // Define this function to handle client selection
            style={{ minWidth: 150 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {cl.nameForCoach} {cl.surnameForCoach}
          </MenuItem>
        );
      };
      return (
        <Menu
          visible={athleteMenu}
          anchor={
            <TouchableOpacity
              onPress={showAthleteMenu}
              style={{
                width: "100%",
                borderRadius: 12,
                borderWidth: 1,
                borderColor: Colors.bubbleColor,
                backgroundColor: Colors.bubbleColor,
                padding: 5,
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                height: 34,
                opacity: isHovered ? 0.7 : 1,
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text
                style={{
                  color: Colors.whiteColor,
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {client.nameForCoach} {client.surnameForCoach}
              </Text>

              {coach
                .clientsInComp(competition)
                .filter(
                  (clientToFilter) =>
                    clientToFilter.id !== client.id &&
                    clientToFilter.nameForCoach
                      .toLowerCase()
                      .includes(searchAthlete.toLowerCase())
                )?.length > 0 && (
                <Feather
                  name={athleteMenu ? "chevron-up" : "chevron-down"}
                  size={18}
                  color={Colors.whiteColor}
                  style={{ marginTop: 2, marginLeft: 4 }}
                />
              )}
            </TouchableOpacity>
          }
          style={[GlobalStyles.menu, { maxHeight: 500 }]}
          onRequestClose={RequestClose}
        >
          <ScrollView>
            {coach
              .clientsInComp(competition)
              .filter(
                (clientToFilter) =>
                  clientToFilter.id !== client.id &&
                  clientToFilter.nameForCoach
                    .toLowerCase()
                    .includes(searchAthlete.toLowerCase())
              )
              .map((cl) => (
                <MenuItemView cl={cl} key={cl.id} />
              ))}
          </ScrollView>
        </Menu>
      );
    };

    const WeightClassMenu = () => {
      const [isHovered, setIsHovered] = useState(false);

      const MenuItemView = ({ weightClass }) => {
        const [isHovered, setIsHovered] = useState(false);
        return (
          <MenuItem
            onPress={() => selectWeightClass(weightClass)}
            style={{ minWidth: 150 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {weightClass}
          </MenuItem>
        );
      };

      return (
        <Menu
          visible={weightClassMenu}
          anchor={
            <TouchableOpacity
              onPress={showWeightClassMenu}
              style={{
                height: 34,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                padding: 5,
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text
                style={{
                  color: Colors.grayColor,
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {competition.weightClass}
              </Text>

              <Feather
                name={"chevron-down"}
                size={18}
                color={Colors.grayColor}
                style={{ marginTop: 2, marginLeft: 4 }}
              />
            </TouchableOpacity>
          }
          style={[GlobalStyles.menu, { marginVertical: 0 }]}
          onRequestClose={() => setWeightClassMenu(false)}
        >
          {weightClasses.map((weightClass, index) => (
            <MenuItemView weightClass={weightClass} key={index} />
          ))}
        </Menu>
      );
    };

    const ClassMenu = () => {
      const [isHovered, setIsHovered] = useState(false);

      const MenuItemView = ({ competitionClass }) => {
        const [isHovered, setIsHovered] = useState(false);
        return (
          <MenuItem
            onPress={() => selectCompetitionClass(competitionClass)} // Define this function to handle client selection
            style={{ minWidth: 150 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {competitionClass}
          </MenuItem>
        );
      };

      return (
        <Menu
          visible={classMenu}
          anchor={
            <TouchableOpacity
              onPress={showClassMenu}
              style={{
                width: "100%",
                height: 34,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                padding: 5,
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text
                style={{
                  color: Colors.grayColor,
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {competition.competitionClass}
              </Text>

              <Feather
                name={"chevron-down"}
                size={18}
                color={Colors.grayColor}
                style={{ marginTop: 2, marginLeft: 4 }}
              />
            </TouchableOpacity>
          }
          style={[GlobalStyles.menu, { marginVertical: 0 }]}
          onRequestClose={() => setClassMenu(false)}
        >
          {competitionClasses.map((competitionClass, index) => (
            <MenuItemView competitionClass={competitionClass} key={index} />
          ))}
        </Menu>
      );
    };

    const LevelMenu = () => {
      const [isHovered, setIsHovered] = useState(false);

      const MenuItemView = ({ level }) => {
        const [isHovered, setIsHovered] = useState(false);
        return (
          <MenuItem
            onPress={() => selectCompetitionLevel(level)} // Define this function to handle client selection
            style={{ minWidth: 150 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {level}
          </MenuItem>
        );
      };

      return (
        <Menu
          visible={levelMenu}
          anchor={
            <TouchableOpacity
              onPress={showLevelMenu}
              style={{
                width: "100%",
                height: 34,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: isHovered
                  ? "rgba(0, 0, 0, 0.5)"
                  : Colors.borderColor,
                padding: 5,
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <Text
                style={{
                  color: Colors.grayColor,
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {competition.competitionLevel}
              </Text>

              <Feather
                name={"chevron-down"}
                size={18}
                color={Colors.grayColor}
                style={{ marginTop: 2, marginLeft: 4 }}
              />
            </TouchableOpacity>
          }
          style={[GlobalStyles.menu, { marginVertical: 0 }]}
          onRequestClose={() => setLevelMenu(false)}
        >
          {competitionLevels.map((level, index) => (
            <MenuItemView level={level} key={index} />
          ))}
        </Menu>
      );
    };

    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          paddingRight:
            screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
          marginBottom: screenSize === "small" ? 12 : 16,
        }}
      >
        <ClientsMenu />

        <View
          style={{
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 16,
          }}
        >
          <View style={{ flex: 1, paddingRight: 4 }}>
            <View
              style={{
                height: 34,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: Colors.borderColor,
                padding: 5,
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  color: Colors.grayColor,
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {client.gender ? t("women-string") : t("men-string")}
              </Text>
            </View>
          </View>
          <View style={{ flex: 1, paddingLeft: 4 }}>
            <WeightClassMenu />
          </View>
        </View>

        <View
          style={{
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 8,
          }}
        >
          <View style={{ flex: 1, paddingRight: 4 }}>
            <ClassMenu />
          </View>

          <View style={{ flex: 1, paddingLeft: 4 }}>
            <LevelMenu />
          </View>
        </View>
      </View>
    );
  };

  const TopEnd = () => {
    const Header = () => {
      return (
        <View style={{ width: "100%" }}>
          <View
            style={[
              GlobalStyles.HStack,
              {
                width: "100%",
                justifyContent: "space-between",
              },
            ]}
          >
            <Text
              style={{
                width: "31.33%",
                textAlign: "center",
                fontSize: 11,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
            >
              {t("squat-string")}
            </Text>
            <Text
              style={{
                width: "31.33%",
                textAlign: "center",
                fontSize: 11,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
            >
              {t("benchPress-string")}
            </Text>
            <Text
              style={{
                width: "31.33%",
                textAlign: "center",
                fontSize: 11,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
            >
              {t("deadlift-string")}
            </Text>
          </View>
        </View>
      );
    };

    const TopEndText = observer(({ exercise }) => {
      const changeProtocol = (text) => {
        const updatedText = text.replace(/,/g, ".");
        competition.setTopEnd(exercise, updatedText);
      };
      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            width: "31.33%",
            alignItems: "center",
          }}
        >
          <TextInput
            placeholder=""
            value={competition.topEndValue(exercise)}
            inputMode="numeric"
            onChangeText={changeProtocol}
            style={{
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
              width: "100%",
              maxWidth: 90,
              borderRadius: 10,
              borderWidth: 0.5,
              color: "black",
              textAlign: "center",
              fontSize: 11,
              paddingVertical: 5,
              outline: "none",
            }}
            maxLength={100}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </View>
      );
    });
    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          paddingHorizontal:
            screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,

          marginBottom: screenSize === "small" ? 16 : 16,
        }}
      >
        <View style={{ justifyContent: "flex-end", marginBottom: 5 }}>
          <Text
            style={[
              Fonts.medium12,
              {
                color: Colors.grayColor,
                marginLeft: 5,
              },
            ]}
          >
            Top end
          </Text>
        </View>
        <View
          style={{
            width: "100%",
            alignItems: "center",
            backgroundColor: Colors.whiteColor,
            borderRadius: 12,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            paddingHorizontal:
              screenSize === "small" ? 16 : screenSize === "medium" ? 8 : 16,
            height: 78,
            justifyContent: "center",
          }}
        >
          <Header />

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: 10,
            }}
          >
            {compExercises.map((exercise, index) => (
              <TopEndText key={index} exercise={exercise} />
            ))}
          </View>
        </View>
      </View>
    );
  };

  const CompetitionInfo = observer(() => {
    const [isEditing, setIsEditing] = useState(false);
    const today = new Date();
    const [newDay, setNewDay] = useState(
      competition
        ? competition.date.getDate().toString()
        : today.getDate().toString()
    );
    const [newMonth, setNewMonth] = useState(
      competition
        ? String(competition.date.getMonth() + 1)
        : String(today.getMonth() + 1)
    );
    const [newYear, setNewYear] = useState(
      competition
        ? competition.date.getFullYear().toString()
        : today.getFullYear().toString()
    );
    const dayInputRef = useRef(null);
    const monthInputRef = useRef(null);
    const yearInputRef = useRef(null);

    useEffect(() => {
      if (isEditing) {
        const timer = setTimeout(() => {
          dayInputRef.current?.focus();
        }, 100);
        return () => clearTimeout(timer);
      }
    }, [isEditing]);

    const handleTextChange = (text, part) => {
      let newText = text.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      let newValue = newText ? parseInt(newText, 10) : "";

      if (part === "day") {
        if (newValue < 1 || newValue > 31) {
          setNewDay(""); // Reset if day is invalid
        } else {
          setNewDay(newValue.toString());
        }
      } else if (part === "month") {
        if (newValue < 1 || newValue > 12) {
          setNewMonth(""); // Reset if month is invalid
        } else {
          setNewMonth(newValue.toString());
        }
      } else if (part === "year") {
        setNewYear(newValue.toString()); // Directly update year without further validation here
      }

      if (newValue.toString().length === 2 && part !== "year") {
        if (part === "day") {
          monthInputRef.current?.focus();
        } else if (part === "month") {
          yearInputRef.current?.focus();
        }
      }
    };

    const handleBlurDate = () => {
      setTimeout(() => {
        if (
          document.activeElement !== dayInputRef.current &&
          document.activeElement !== monthInputRef.current &&
          document.activeElement !== yearInputRef.current
        ) {
          setIsEditing(false);

          competition.date = new Date(
            newYear !== "" ? newYear : today.getFullYear(),
            newMonth !== "" ? newMonth - 1 : today.getMonth(),
            newDay !== "" ? newDay : today.getDate(),
            12
          );

          if (newYear === "") {
            setNewYear(today.getFullYear().toString());
          }
          if (newMonth === "") {
            setNewMonth(String(today.getMonth() + 1));
          }
          if (newDay === "") {
            setNewDay(today.getDate().toString());
          }
        }
      }, 10);
    };

    const handleTextClick = () => {
      setIsEditing(true);
    };

    const changeHour = (text) => {
      competition.setProperty("hour", text);
    };
    const changeWeightIn = (text) => {
      competition.setProperty("weightIn", text);
    };

    const DateButton = () => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TouchableOpacity
          onPress={handleTextClick}
          style={{
            width: "100%",
            height: 34,
            borderRadius: 10,
            borderWidth: 1,
            borderColor: Colors.borderColor,
            padding: 5,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            opacity: isHovered ? 0.7 : 1,
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {screenSize === "large" && (
            <Ionicons
              name="calendar-outline"
              size={18}
              color={Colors.grayColor}
              style={{ marginRight: 10 }}
            />
          )}

          <Text
            style={{
              color: Colors.grayColor,
              fontSize: screenSize === "small" ? 12 : 14,
              textAlign: "center",
              textAlignVertical: "center",
            }}
          >
            {newDay} / {newMonth} / {newYear}
          </Text>
        </TouchableOpacity>
      );
    };

    const TimeText = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TextInput
          style={[
            GlobalStyles.textInputStyle,
            {
              fontSize: screenSize === "small" ? 12 : 14,

              flex: 1,
              height: 34,
              borderRadius: 10,
              borderWidth: 0.1,
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
              margin: 0,
            },
          ]}
          placeholder={t("competitionTime-string")}
          placeholderTextColor={Colors.grayColor}
          value={competition.hour}
          onChangeText={changeHour}
          maxLength={50}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      );
    });

    const WeightInText = observer(() => {
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TextInput
          style={[
            GlobalStyles.textInputStyle,
            {
              flex: 1,
              fontSize: screenSize === "small" ? 12 : 14,

              height: 34,
              borderRadius: 10,
              borderWidth: 0.1,
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
              margin: 0,
            },
          ]}
          placeholder={t("weightInTime-string")}
          placeholderTextColor={Colors.grayColor}
          value={competition.weightIn}
          onChangeText={changeWeightIn}
          maxLength={50}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      );
    });
    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          paddingLeft:
            screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
          marginBottom: screenSize === "small" ? 16 : 16,
        }}
      >
        <View
          style={{
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <View style={{ flex: 1, paddingRight: 4 }}>
            {isEditing ? (
              <View
                style={{
                  width: "100%",
                  height: 34,
                  borderRadius: 10,
                  borderWidth: 1,
                  borderColor: Colors.borderColor,
                  padding: 5,
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <TextInput
                  ref={dayInputRef}
                  onBlur={handleBlurDate}
                  style={{
                    width: screenSize === "medium" ? 16 : 30,
                    textAlign: "center",
                    fontSize: screenSize === "small" ? 12 : 14,
                  }}
                  inputMode="numeric"
                  maxLength={2}
                  onChangeText={(text) => handleTextChange(text, "day")}
                  value={newDay}
                  placeholder="DD"
                  placeholderTextColor={Colors.grayColor}
                  returnKeyType="next"
                  onSubmitEditing={() => monthInputRef.current?.focus()}
                />
                <Text
                  style={{
                    fontSize: screenSize === "small" ? 12 : 14,
                    color: Colors.grayColor,
                  }}
                >
                  /
                </Text>
                <TextInput
                  ref={monthInputRef}
                  onBlur={handleBlurDate}
                  style={{
                    width: screenSize === "medium" ? 16 : 30,
                    textAlign: "center",
                    fontSize: screenSize === "small" ? 12 : 14,
                  }}
                  inputMode="numeric"
                  maxLength={2}
                  onChangeText={(text) => handleTextChange(text, "month")}
                  value={newMonth}
                  placeholder="MM"
                  placeholderTextColor={Colors.grayColor}
                  returnKeyType="next"
                  onSubmitEditing={() => yearInputRef.current?.focus()}
                />
                <Text
                  style={{
                    fontSize: screenSize === "small" ? 12 : 14,
                    color: Colors.grayColor,
                  }}
                >
                  /
                </Text>
                <TextInput
                  ref={yearInputRef}
                  onBlur={handleBlurDate}
                  style={{
                    width: screenSize === "medium" ? 34 : 50,
                    textAlign: "center",
                    fontSize: screenSize === "small" ? 12 : 14,
                  }}
                  inputMode="numeric"
                  maxLength={4}
                  onChangeText={(text) => handleTextChange(text, "year")}
                  value={newYear}
                  placeholder="YYYY"
                  placeholderTextColor={Colors.grayColor}
                />
              </View>
            ) : (
              <DateButton />
            )}
          </View>
          <View style={{ flex: 1, paddingLeft: 4 }}>
            <View
              style={{
                width: "100%",
                height: 34,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: Colors.borderColor,
                padding: 5,
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Text
                style={{
                  color: Colors.grayColor,
                  fontSize: screenSize === "small" ? 12 : 14,
                }}
              >
                {competition.weeksOut(t)}
              </Text>
            </View>
          </View>
        </View>
        <View
          style={{
            width: "100%",
            flexDirection: "row",
            justifyContent: "space-between",
            marginTop: 8,
          }}
        >
          <View style={{ flex: 1, paddingRight: 4 }}>
            <TimeText />
          </View>
          <View style={{ flex: 1, paddingLeft: 4 }}>
            <WeightInText />
          </View>
        </View>
      </View>
    );
  });

  const ExerciseView = ({ exercise }) => {
    const ExerciseHandling = () => {
      const Header = () => {
        const string =
          exercise === "squat"
            ? "squat-string"
            : exercise === "bench press"
            ? "benchPress-string"
            : "deadlift-string";
        return (
          <>
            <Text
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 12,
                fontWeight: "500",
                color: Colors.grayColor,
                marginVertical: 10,
              }}
            >
              {t(string).toUpperCase()}
            </Text>
            <View
              style={{
                height: 1,
                backgroundColor: Colors.borderColor,
                width: "100%",
              }}
            />
            <View
              style={[
                GlobalStyles.HStack,
                {
                  width: "100%",
                  justifyContent: "space-between",
                  marginVertical: 10,
                },
              ]}
            >
              <Text
                style={{
                  width: "31.33%",
                  textAlign: "center",
                  fontSize: 11,
                  fontWeight: "500",
                  color: Colors.grayColor,
                }}
                numberOfLines={2}
              >
                {t("firstTry-string")}
              </Text>
              <Text
                style={{
                  width: "31.33%",
                  textAlign: "center",
                  fontSize: 11,
                  fontWeight: "500",
                  color: Colors.grayColor,
                }}
                numberOfLines={2}
              >
                {t("secondTry-string")}
              </Text>
              <Text
                style={{
                  width: "31.33%",
                  textAlign: "center",
                  fontSize: 11,
                  fontWeight: "500",
                  color: Colors.grayColor,
                }}
                numberOfLines={2}
              >
                {t("thirdTry-string")}
              </Text>
            </View>
          </>
        );
      };

      const AttemptView = ({ attemptIndex }) => {
        const AttemptText = observer(
          ({ exercise, attemptIndex, qualityAttempt, qualityIndex }) => {
            const changeProtocol = (text) => {
              const updatedText = text.replace(/,/g, ".");
              competition.setAttempt(
                exercise,
                attemptIndex,
                qualityAttempt,
                updatedText
              );
            };
            const [isHovered, setIsHovered] = useState(false);

            return (
              <View
                style={{
                  width: "100%",
                  marginBottom: 10,
                }}
              >
                <TextInput
                  placeholder=""
                  value={competition.attemptValue(
                    exercise,
                    attemptIndex,
                    qualityAttempt
                  )}
                  onChangeText={changeProtocol}
                  inputMode="numeric"
                  style={{
                    borderColor: isHovered
                      ? "rgba(0, 0, 0, 0.5)"
                      : Colors.borderColor,
                    width: "100%",
                    maxWidth: 90,
                    alignSelf: "center",
                    borderRadius: 10,
                    borderWidth: 0.5,
                    color: "black",
                    textAlign: "center",
                    fontSize: 11,
                    padding: 5,
                    backgroundColor:
                      qualityIndex === 0
                        ? "rgba(174, 239, 163, 0.2)"
                        : qualityIndex === 1
                        ? "rgba(250, 184, 109, 0.2)"
                        : "rgba(230, 98, 80, 0.2)",
                    outline: "none",
                  }}
                  maxLength={100}
                  onMouseEnter={() => !isMobile && setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                />
              </View>
            );
          }
        );
        return (
          <View
            style={{
              width: "31.33%",
            }}
          >
            {qualityAttempts.map((qualityAttempt, qualityIndex) => (
              <AttemptText
                exercise={exercise}
                attemptIndex={attemptIndex}
                qualityAttempt={qualityAttempt}
                qualityIndex={qualityIndex}
                key={qualityIndex}
              />
            ))}
          </View>
        );
      };
      return (
        <View
          style={{
            width: "100%",
            alignItems: "center",
            backgroundColor: Colors.whiteColor,
            borderRadius: 12,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            paddingHorizontal:
              screenSize === "small" ? 20 : screenSize === "medium" ? 8 : 16,
          }}
        >
          <Header />

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {attempts.map((attempt, index) => (
              <AttemptView key={index} attempt={attempt} attemptIndex={index} />
            ))}
          </View>
        </View>
      );
    };

    const ExerciseWarmpus = () => {
      const WarmupText = observer(({ exercise, warmupIndex }) => {
        const changeWarmup = (text) => {
          const updatedText = text.replace(/,/g, ".");
          competition.setWarmup(exercise, warmupIndex, updatedText);
        };
        return (
          <TextInput
            placeholder=""
            value={competition.warmupValue(exercise, warmupIndex)}
            onChangeText={changeWarmup}
            style={{
              width: "10%",
              color: "black",
              textAlign: "center",
              fontSize: screenSize != "large" ? 10 : 11,
              paddingVertical: 4,
              outline: "none",
            }}
            maxLength={100}
          />
        );
      });
      return (
        <View style={{ marginTop: 8 }}>
          <Text
            style={[
              Fonts.medium12,
              { color: Colors.grayColor, marginLeft: 5, marginBottom: 5 },
            ]}
          >
            {t("warmups-string")}
          </Text>
          <View
            style={{
              width: "100%",
              alignItems: "center",
              backgroundColor: Colors.whiteColor,
              borderRadius: 12,
              borderWidth: 0.1,
              borderColor: Colors.borderColor,
              paddingHorizontal: 5,
              paddingVertical: 5,
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            {Array.from({ length: 8 }, (_, index) => (
              <React.Fragment key={index}>
                <WarmupText exercise={exercise} warmupIndex={index} />
                {index !== 7 && <View style={styles.warmupSeparator} />}
              </React.Fragment>
            ))}
          </View>
        </View>
      );
    };

    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          paddingRight:
            screenSize === "small"
              ? 0
              : exercise != "deadlift"
              ? screenSize === "medium"
                ? 8
                : 12
              : 0,
          paddingLeft:
            screenSize === "small"
              ? 0
              : exercise != "squat"
              ? screenSize === "medium"
                ? 8
                : 12
              : 0,
          marginBottom: screenSize === "small" ? 16 : 16,
        }}
      >
        <ExerciseHandling />
        <ExerciseWarmpus />
      </View>
    );
  };

  const MarcasMinimas = () => {
    const Header = () => {
      return (
        <View
          style={[
            GlobalStyles.HStack,
            {
              width: "100%",
              justifyContent: "space-between",
              marginVertical: 10,
            },
          ]}
        >
          <Text
            style={{
              width: "23%",
              textAlign: "center",
              fontSize: 11,
              fontWeight: "500",
              color: Colors.grayColor,
            }}
            numberOfLines={2}
          >
            {t("minimumTotal-string")}
          </Text>
          <Text
            style={{
              width: "23%",
              textAlign: "center",
              fontSize: 11,
              fontWeight: "500",
              color: Colors.grayColor,
            }}
            numberOfLines={2}
          >
            {t("goodTotal-string")}
          </Text>
          <Text
            style={{
              width: "23%",
              textAlign: "center",
              fontSize: 11,
              fontWeight: "500",
              color: Colors.grayColor,
            }}
            numberOfLines={2}
          >
            {t("mediumTotal-string")}
          </Text>
          <Text
            style={{
              width: "23%",
              textAlign: "center",
              fontSize: 11,
              fontWeight: "500",
              color: Colors.grayColor,
            }}
            numberOfLines={2}
          >
            {t("badTotal-string")}
          </Text>
        </View>
      );
    };

    const MarcaMinimaText = observer(() => {
      const changeProtocol = (text) => {
        const updatedText = text.replace(/,/g, ".");
        competition.setProperty("minimumMark", updatedText);
      };
      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            width: "23%",
            alignItems: "center",
          }}
        >
          <TextInput
            placeholder=""
            value={competition.minimumMark}
            onChangeText={changeProtocol}
            inputMode="numeric"
            style={{
              borderColor: isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,
              width: "100%",
              maxWidth: 90,
              alignSelf: "center",
              borderRadius: 10,
              borderWidth: 0.5,
              color: "black",
              textAlign: "center",
              fontSize: 11,
              padding: 5,
              outline: "none",
            }}
            maxLength={100}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </View>
      );
    });

    const TotalText = observer(({ qualityIndex }) => {
      return (
        <View style={{ width: "23%" }}>
          <View
            style={{
              flex: 1,
              width: "100%",
              maxWidth: 90,
              alignSelf: "center",
              alignItems: "center",
              borderColor: Colors.borderColor,
              borderRadius: 10,
              borderWidth: 0.5,
              backgroundColor:
                qualityIndex === 0
                  ? "rgba(174, 239, 163, 0.2)"
                  : qualityIndex === 1
                  ? "rgba(250, 184, 109, 0.2)"
                  : "rgba(230, 98, 80, 0.2)",
            }}
          >
            <Text
              style={{
                color: "black",
                textAlign: "center",
                fontSize: 11,
                paddingVertical: 5,
                width: "100%",
              }}
              numberOfLines={1}
            >
              {isNaN(competition.getTotal(qualityIndex)) ||
              competition.getTotal(qualityIndex) === 0
                ? "-"
                : competition.getTotal(qualityIndex)}
            </Text>
          </View>
        </View>
      );
    });

    const DifferenceText = observer(({ qualityIndex }) => {
      const symbol = competition.getMinimumDiff(qualityIndex) > 0 ? "+" : "";
      return (
        <Text
          style={{
            width: "23%",
            color:
              competition.getMinimumDiff(qualityIndex) > 0
                ? "green"
                : competition.getMinimumDiff(qualityIndex) < 0
                ? "red"
                : Colors.blackColor,
            textAlign: "center",
            fontSize: 11,
            paddingVertical: 5,
          }}
          numberOfLines={1}
        >
          {isNaN(competition.getMinimumDiff(qualityIndex))
            ? ""
            : `${symbol}${competition.getMinimumDiff(qualityIndex)}`}
        </Text>
      );
    });
    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          paddingRight:
            screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
        }}
      >
        <View
          style={{
            width: "100%",
            alignItems: "center",
            backgroundColor: Colors.whiteColor,
            borderRadius: 12,
            borderWidth: 0.1,
            borderColor: Colors.borderColor,
            paddingHorizontal: 10,
            justifyContent: "space-around",
            height: 110,
          }}
        >
          <Header />

          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: 10,
            }}
          >
            <MarcaMinimaText />
            <TotalText qualityIndex={0} />
            <TotalText qualityIndex={1} />
            <TotalText qualityIndex={2} />
          </View>
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <Text
              style={{
                width: "23%",
                textAlign: "center",
                fontSize: 11,
                fontWeight: "500",
                color: Colors.grayColor,
              }}
              numberOfLines={1}
            >
              {t("difference-string")}
            </Text>
            <DifferenceText qualityIndex={0} />
            <DifferenceText qualityIndex={1} />
            <DifferenceText qualityIndex={2} />
          </View>
        </View>
      </View>
    );
  };

  const CompetitionNotes = observer(() => {
    const handleChange = (text) => {
      competition.setProperty("notes", text);
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          marginTop: screenSize === "small" ? 16 : 0,
          paddingHorizontal:
            screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
        }}
      >
        <TextInput
          value={competition.notes}
          onChangeText={handleChange}
          multiline
          placeholder={t("competitionNotes-string")}
          placeholderTextColor={Colors.grayColor}
          numberOfLines={4} // Adjust as n
          style={{
            flex: 1,
            borderRadius: 12,
            borderWidth: 0.1,
            borderColor: isHovered ? "rgba(0, 0, 0, 0.5)" : Colors.borderColor,
            backgroundColor: Colors.whiteColor,
            fontSize: 11,
            padding: 10,
            outline: "none",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      </View>
    );
  });

  const CompetitionGoals = observer(() => {
    const GoalText = observer(({ goalIndex }) => {
      const handleChange = (text) => {
        competition.setGoal(goalIndex, text);
      };
      const [isHovered, setIsHovered] = useState(false);

      return (
        <TextInput
          placeholder={
            goalIndex === 0
              ? t("firstGoal-string")
              : goalIndex === 1
              ? t("secondGoal-string")
              : t("thirdGoal-string")
          }
          placeholderTextColor={Colors.grayColor}
          value={competition.goals[goalIndex]}
          onChangeText={handleChange}
          numberOfLines={1}
          style={{
            width: "100%",
            borderRadius: 10,
            borderWidth: 0.1,
            borderColor: isHovered ? "rgba(0, 0, 0, 0.5)" : Colors.borderColor,
            backgroundColor: Colors.whiteColor,
            color: "black",
            textAlign: "center",
            fontSize: 11,
            paddingHorizontal: 10,
            paddingVertical: screenSize === "small" ? 8 : "auto",
            outline: "none",

            flex: 1,
          }}
          maxLength={100}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        />
      );
    });

    return (
      <View
        style={{
          width: screenSize === "small" ? "100%" : "33.333%",
          paddingLeft:
            screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
          justifyContent: "space-between",
          marginTop: screenSize === "small" ? 16 : 0,
          gap: 8,
        }}
      >
        <GoalText order={"Primer"} goalIndex={0} />
        <GoalText order={"Segundo"} goalIndex={1} />
        <GoalText order={"Tercer"} goalIndex={2} />
      </View>
    );
  });

  const CompetitionRecap = () => {
    const RecapAttempts = () => {
      const Header = ({ string }) => {
        return (
          <View
            style={{
              flexDirection: screenSize === "small" ? "column" : "row",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: screenSize === "small" ? 8 : 8,
            }}
          >
            <View style={{ width: screenSize === "small" ? "100%" : "100%" }}>
              <Text
                style={{
                  width: "100%",
                  textAlign: "center",
                  fontSize: 12,
                  fontWeight: "500",
                  color: Colors.grayColor,
                }}
              >
                {t(string).toUpperCase()}
              </Text>
              <View
                style={{
                  height: 1,
                  backgroundColor: Colors.borderColor,
                  width: "100%",
                  marginVertical: 5,
                }}
              />
              <View
                style={[
                  GlobalStyles.HStack,
                  {
                    width: "100%",
                    justifyContent: "space-between",
                  },
                ]}
              >
                <Text
                  style={{
                    width: "31.33%",
                    textAlign: "center",
                    fontSize: 11,
                    fontWeight: "500",
                    color: Colors.grayColor,
                  }}
                  numberOfLines={2}
                >
                  {t("firstTry-string")}
                </Text>
                <Text
                  style={{
                    width: "31.33%",
                    textAlign: "center",
                    fontSize: 11,
                    fontWeight: "500",
                    color: Colors.grayColor,
                  }}
                  numberOfLines={2}
                >
                  {t("secondTry-string")}
                </Text>
                <Text
                  style={{
                    width: "31.33%",
                    textAlign: "center",
                    fontSize: 11,
                    fontWeight: "500",
                    color: Colors.grayColor,
                  }}
                  numberOfLines={2}
                >
                  {t("thirdTry-string")}
                </Text>
              </View>
            </View>
          </View>
        );
      };

      const RecapAttemptView = ({ exercise }) => {
        const RecapAttemptText = observer(({ attemptIndex }) => {
          const changeProtocol = (text) => {
            const updatedText = text.replace(/,/g, ".");
            competition.setRecapAttempt(
              exercise,
              attemptIndex,
              "result",
              updatedText
            );
          };
          const [isHovered, setIsHovered] = useState(false);
          const [isButtonHovered, setIsButtonHovered] = useState(false);
          return (
            <View
              style={{
                width: "31.33%",
                alignItems: "center",
              }}
            >
              <TextInput
                placeholder=""
                value={competition.recapAttemptValue(
                  exercise,
                  attemptIndex,
                  "result"
                )}
                onChangeText={changeProtocol}
                inputMode="numeric"
                style={{
                  borderColor: isHovered
                    ? "rgba(0, 0, 0, 0.5)"
                    : Colors.borderColor,
                  width: "100%",
                  maxWidth: 90,
                  borderRadius: 10,
                  borderWidth: 0.5,
                  color: "black",
                  textAlign: "center",
                  fontSize: 11,
                  paddingVertical: 5,
                  outline: "none",
                }}
                maxLength={100}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              />
              <TouchableOpacity
                onPress={() =>
                  competition.setRecapAttempt(exercise, attemptIndex, "isNull")
                }
                style={{ marginTop: 8 }}
                onMouseEnter={() => !isMobile && setIsButtonHovered(true)}
                onMouseLeave={() => setIsButtonHovered(false)}
              >
                <View
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: 50,
                    borderWidth: 1,
                    borderColor: Colors.borderColor,
                    backgroundColor: competition.recapAttemptValue(
                      exercise,
                      attemptIndex,
                      "isNull"
                    )
                      ? Colors.redColor
                      : isButtonHovered
                      ? Colors.redColor
                      : Colors.whiteColor,
                    opacity: isButtonHovered ? 0.5 : 1,
                  }}
                />
              </TouchableOpacity>
            </View>
          );
        });
        return (
          <View
            style={{
              width: screenSize === "small" ? "100%" : "100%",
              flexDirection: "row",
              justifyContent: "space-between",
              marginBottom: screenSize === "small" ? 12 : 0,
            }}
          >
            {Array.from({ length: 3 }, (_, index) => (
              <RecapAttemptText key={index} attemptIndex={index} />
            ))}
          </View>
        );
      };

      const RecapTotal = () => {
        const TotalText = observer(() => {
          return (
            <View
              style={{
                width: 60,
                height: 24,
                alignItems: "center",
                justifyContent: "center",
                borderColor: Colors.borderColor,
                borderRadius: 10,
                borderWidth: 0.5,
              }}
            >
              <Text
                style={{
                  color: "black",
                  textAlign: "center",
                  fontSize: 11,
                  padding: 5,
                  width: "100%",
                }}
                numberOfLines={1}
              >
                {isNaN(competition.recapTotal) ? "" : competition.recapTotal}
              </Text>
            </View>
          );
        });
        return (
          <View
            style={{
              width: "100%",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Text style={[Fonts.medium14, { marginRight: 5, marginBottom: 2 }]}>
              {t("competitionTotal-string")}
            </Text>

            <TotalText />
          </View>
        );
      };
      return (
        <View
          style={{
            width: screenSize === "small" ? "100%" : "66.666%",
            paddingRight:
              screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
          }}
        >
          <View
            style={{
              flex: 1,
              alignItems: "center",
              backgroundColor: Colors.whiteColor,
              borderRadius: 12,
              borderWidth: 0.1,
              borderColor: Colors.borderColor,
              paddingHorizontal:
                screenSize === "small" ? 8 : screenSize === "medium" ? 8 : 16,
              paddingVertical: 10,
            }}
          >
            <View
              style={{
                width: "100%",

                flexDirection: screenSize === "small" ? "column" : "row",
                justifyContent: "space-between",
                marginTop: 5,
                gap: 8,
              }}
            >
              <View
                style={{
                  flex: 1,
                  marginRight: screenSize === "small" ? 0 : 8,
                }}
              >
                <Header string={"squat-string"} />
                <RecapAttemptView exercise={"squat"} />
              </View>
              <View
                style={{
                  flex: 1,
                  marginRight: screenSize === "small" ? 0 : 8,
                }}
              >
                <Header string={"benchPress-string"} />
                <RecapAttemptView exercise={"bench press"} />
              </View>

              <View style={{ flex: 1 }}>
                <Header string={"deadlift-string"} />
                <RecapAttemptView exercise={"deadlift"} />
              </View>
            </View>

            <RecapTotal />
          </View>
        </View>
      );
    };
    const RecapNotes = observer(() => {
      const handleChange = (text) => {
        competition.setProperty("recapNotes", text);
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        <View
          style={{
            width: screenSize === "small" ? "100%" : "33.333%",
            paddingLeft:
              screenSize === "small" ? 0 : screenSize === "medium" ? 8 : 12,
            marginTop: screenSize === "small" ? 16 : 0,
          }}
        >
          <TextInput
            value={competition.recapNotes}
            onChangeText={handleChange}
            multiline
            placeholder={t("competitionRecapNotes-string")}
            placeholderTextColor={Colors.grayColor}
            numberOfLines={4} // Adjust as n
            style={{
              height: "100%",
              borderRadius: 12,
              borderWidth: 0.1,
              borderColor: isHovered ? Colors.borderColor : Colors.borderColor,
              backgroundColor: Colors.whiteColor,
              fontSize: 11,
              padding: 10,
              outline: "none",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          />
        </View>
      );
    });
    return (
      <View style={{ marginTop: screenSize === "small" ? 16 : 24 }}>
        <Text style={[Fonts.medium18, { marginLeft: 5 }]}>
          {t("competitionRecap-string")}
        </Text>

        <View
          style={{
            flexDirection: screenSize === "small" ? "column" : "row",
            width: "100%",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <RecapAttempts />
          <RecapNotes />
        </View>
      </View>
    );
  };

  return (
    <>
      <View
        style={{
          flex: 1,
          justifyContent: "space-between",
        }}
      >
        <CompetitionHeaderTop />

        <View
          style={{
            width: "100%",
            flexDirection: screenSize === "small" ? "column" : "row",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginTop: screenSize === "small" ? 16 : 24,
          }}
        >
          <AthleteInfo />
          {screenSize === "small" ? (
            <>
              <CompetitionInfo />
              <TopEnd />
            </>
          ) : (
            <>
              <TopEnd />
              <CompetitionInfo />
            </>
          )}
        </View>

        <View
          style={{
            width: "100%",
            flexDirection: screenSize === "small" ? "column" : "row",
            justifyContent: "space-between",
          }}
        >
          <ExerciseView exercise={"squat"} />
          <ExerciseView exercise={"bench press"} />
          <ExerciseView exercise={"deadlift"} />
        </View>

        <View
          style={{
            width: "100%",
            flexDirection: screenSize === "small" ? "column" : "row",
            justifyContent: "space-between",
          }}
        >
          <MarcasMinimas />
          <CompetitionNotes />
          <CompetitionGoals />
        </View>

        <CompetitionRecap />
      </View>
      {showingFederationChangeAlert && (
        <CustomAlert
          isVisible={showingFederationChangeAlert}
          onClose={() => {
            setShowingFederationChangeAlert(false);
            setPendingCompetitionLevel("");
          }}
          title={"competitionFederationChangeAlertTitle-string"}
          text={"competitionFederationChangeAlertText-string"}
          action={async () => {
            applyCompetitionLevelChange(pendingCompetitionLevel, true);
          }}
          specialCTA={"continue-string"}
        />
      )}
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.backgroundColor,
  },
  warmupSeparator: {
    width: 1,
    backgroundColor: Colors.borderColor,
    height: "80%",
  },
});

export default ClientGameDay;
